/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    DUPLICITY: 'duplicity',
    PERSONAL_INFO_EMAIL_DUPLICITY: 'personal_info_email_duplicity',
    ORG_EMAIL_DUPLICITY: 'org_email_duplicity',
    EXISTING_OFFICE_EMPLOYEE: 'existing_office_employee',
    EXISTING_OFFICE_CLIENT: 'existing_office_client',
    OFFICE_CLIENT_ACTIVE_FILLED_DYNAMIC_REGISTRATION: 'office_client_active_filled_dynamic_registration',
    PROMO_CODE_VOUCHER_VALIDATION: 'promo_code_voucher_validation',
};
